<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useLoginStore } from '@/login/stores/useLoginStore';
import { getApiHost } from '@/appSettings';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

const loginStore = useLoginStore();
const { saveUsername, savedUsername } = storeToRefs(loginStore);

const error = ref<string | null>(null);
const username = ref(savedUsername.value ?? '');

const route = useRoute();
const { t } = useI18n();

const ssologin = (): void => {
    error.value = null;

    if (saveUsername.value) {
        loginStore.setSavedUsername(username.value);
    }

    const redirectUrl = `https://${getApiHost()}/sso-service/user/${username.value}`;
    window.location.assign(redirectUrl);
};

onMounted(() => {
    if (route.query.ssoerr === '3') {
        error.value = t('components.login.errors.cannotUseSSO');
    }
});
</script>

<template>
    <SAlert variant="danger" v-if="error" class="mb-4">
        {{ error }}
    </SAlert>
    <form @submit.prevent>
        <SFormGroup id="field" :label="$t('system.username')" class="mb-4">
            <SFormInput v-model="username" type="text" />
        </SFormGroup>
        <SStack class="justify-content-between align-items-center mb-8">
            <SFormCheckbox
                id="remember-me"
                v-model="saveUsername"
                :label="$t('system.rememberMe')"
            />
        </SStack>
        <SButton
            variant="primary"
            class="w-100"
            @click="ssologin"
        >
            {{ $t('components.login.login') }}
        </SButton>
    </form>
</template>
